import { render, staticRenderFns } from "./curveDetailTem.vue?vue&type=template&id=d27e5814"
import script from "./curveDetailTem.vue?vue&type=script&lang=js"
export * from "./curveDetailTem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports